import { useState } from "react";
import { CircularProgress } from "@mui/material";

import PrimaryButton from "../../../Components/Buttons/primary-button";
import SelectField from "../../../Components/Form Fields/select-field";

import { useTerminateCard } from "../../../CustomHooks/Mutations";

import { useModalContext } from "../../../Contexts/ModalContext";

import { dispatchErrorToast, dispatchSuccessToast } from "../../../Utils/helpers";
import { CARD_STATUS_REASONS, modalVariants } from "../../../Utils/constants";

import { CircleExclamation } from "../../../Assets/Icons";

export default function renderTerminateCard(modalContext, props) {
  const { updateModalComponent, setModalVariant, setModalTitle, setModalClassName, setModalAriaLabel } = modalContext;

  updateModalComponent(() => <TerminateCardModal {...props} />);
  setModalVariant(modalVariants.promptDialog);
  setModalTitle("");
  setModalAriaLabel?.("Terminate card");
  setModalClassName("");
}

function TerminateCardModal({ cardId, onTerminated }) {
  const { onModalClose } = useModalContext();

  const [reason, setReason] = useState("");

  const { isLoading, mutate: terminateCard } = useTerminateCard({
    onSuccess: () => {
      dispatchSuccessToast("Your card has been terminated.", { key: `terminate-card-${cardId}` });
      onModalClose();
      onTerminated && onTerminated();
    },
    onError: (e) =>
      dispatchErrorToast(e?.response?.data?.error || "Unable to terminate card. Please try again.", {
        key: `terminate-card-${cardId}`,
      }),
  });

  return (
    <>
      <div className="modal-dialog-content">
        <CircleExclamation className="modal-status-icon alert-error mb-4" />
        <h3 className="modal-status-title mt-5 mb-2">Terminate this card?</h3>
        <span className="modal-content-text mb-4">
          This permanently deactivates the card. This action can&apos;t be undone, and a terminated card can&apos;t be
          re-enabled.
        </span>
        <SelectField
          className="filled w-100"
          label="Reason"
          options={CARD_STATUS_REASONS}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          displayEmpty
          renderValue={(selected) =>
            CARD_STATUS_REASONS.find((option) => option.value === selected)?.label || "Select a reason"
          }
        />
      </div>
      <div className="action-container split-equally">
        <PrimaryButton
          className="red-theme"
          onClick={() => terminateCard({ reason, cardId })}
          disabled={!reason || isLoading}
        >
          Terminate Card {isLoading && <CircularProgress />}
        </PrimaryButton>
        <PrimaryButton className="secondary-colors" onClick={() => onModalClose()}>
          Cancel
        </PrimaryButton>
      </div>
    </>
  );
}
